export default __webpack_public_path__ + "static/media/silhouette_epilogue.eb08974f.png";